import { Typography } from '@mui/material';
import { type ComponentProps, useMemo } from 'react';
import { combineSx } from '@/utils/combineSx';
import { formatDateWithOptions } from '@/utils/formatDate';

const updatedAtStyles = {
  text: {
    fontSize: '0.625rem',
    textTransform: 'uppercase',
    letterSpacing: '0.08em',
  },
};

type UpdatedAtProps = {
  date: string | null | undefined;
  prefix?: string;
  format?: Intl.DateTimeFormatOptions;
} & ComponentProps<typeof Typography>;

const UpdatedAt = ({
  date,
  prefix = 'updated: ',
  format = {
    month: 'long',
    year: 'numeric',
  },
  sx,
}: UpdatedAtProps) => {
  const formattedDate = useMemo(() => {
    return date ? formatDateWithOptions(date, { format }) : '—';
  }, [date, format]);

  const textContent = useMemo(() => {
    return `${prefix} ${formattedDate}`;
  }, [prefix, formattedDate]);

  return (
    <Typography
      variant='caption'
      color='text.secondary'
      sx={combineSx(updatedAtStyles.text, sx)}
      data-id='updated-at'
    >
      {textContent}
    </Typography>
  );
};

export { UpdatedAt };
export type { UpdatedAtProps };
